import { Column } from '~/commonComponents/Column';
import { Text } from '~/commonComponents/Text';
import { EmptyFavoriteProfessionalCopy } from '~/components/ProfessionalsHub/Constants';
import { Colors } from '~/themes/colors';

export const NoFavorite = () => {
  return (
    <Column alignItems="center">
      <EmptyFavoriteProfessionalCopy.Icon size={136} />

      <Text bold color={Colors.neutral_500} fontSize={20} marginTop={18}>
        {EmptyFavoriteProfessionalCopy.title}
      </Text>
      <Column width="95%" gap={16} marginTop={18}>
        <Text color={Colors.neutral_500}>{EmptyFavoriteProfessionalCopy.description}</Text>
        <ul
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
            marginLeft: -20,
            marginTop: 20,
          }}
        >
          {EmptyFavoriteProfessionalCopy.steps.map(({ description, title }) => (
            <li key={title}>
              <Text bold color={Colors.neutral_500}>
                {title}
              </Text>{' '}
              <Text color={Colors.neutral_500}>{description}</Text>
            </li>
          ))}
        </ul>
      </Column>
    </Column>
  );
};
